import axios from "axios";
import API from "../api";
import Vue from "vue";

export const VendorModule = {
  state: {
    vendor: {},
    isRequesting: false,
    errored: false,
    error: "",
    channexStatus: 0,
    channexRoomTypes: []
  },
  actions: {
    getVendorData({ commit }) {
      return new Promise((resolve, reject) => {
        commit("VENDOR_REQUEST_START");
        axios
          .get(`${API.BASE_URL}${API.VENDOR_CURRENT}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("VENDOR_DATA_SUCCESS", response.data);
              resolve(response.data);
            } else {
              commit("VENDOR_REQUEST_FAILED", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("VENDOR_REQUEST_FAILED", error);
            reject(error.message);
          });
        });
    },

    addStripeToken({ commit }, cardInfo) {
      return new Promise((resolve, reject) => {
        commit("VENDOR_REQUEST_START");
        return axios
          .post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_TOKEN}`, cardInfo, API.RequestHeaders())
          .then(response => {
            if (response.status == 200) {
              commit("VENDOR_REQUEST_SUCCESS")
              resolve(response.data);
            } else {
              commit("VENDOR_REQUEST_FAILED", response.data);
              reject('Failed to get stripe token');
            }
          })
          .catch(error => {
            commit("VENDOR_REQUEST_FAILED", error.message);
            reject(error.response.data || error.message);
          });
      });
    },

    addStripeCharge({ commit }, paymentInfo) {
      return new Promise((resolve, reject) => {
        commit("VENDOR_REQUEST_START");
        return axios
          .post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_CHARGE}`, paymentInfo, API.RequestHeaders())
          .then(response => {
            if (response.status == 200) {
              commit("VENDOR_REQUEST_SUCCESS")
              resolve(response.data);
            } else {
              commit("VENDOR_REQUEST_FAILED", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("VENDOR_REQUEST_FAILED", error.message);
            reject(error.message);
          });
      });
    },

    processPayment({ commit }, paymentInfo) {
      return new Promise((resolve, reject) => {
        commit("VENDOR_REQUEST_START");
        return axios
          .post(`${API.BASE_URL}${API.BACKEND_PAYMENT}`, paymentInfo, API.RequestHeaders())
          .then(response => {
            if (response.status == 200) {
              commit("VENDOR_REQUEST_SUCCESS")
              resolve(response.data);
            } else {
              commit("VENDOR_REQUEST_FAILED", response.data);
              reject(response.data);
            }
          })
          .catch(error => {
            commit("VENDOR_REQUEST_FAILED", error.message);
            reject(error.message);
          });
      });
    },

    verifyStripeConnection({ commit }, auth_code) {
      return new Promise((resolve, reject) => {
        commit("VENDOR_REQUEST_START");
        return axios
          .post(`${API.BASE_URL}${API.VENDOR}${API.STRIPE_CONNECT}`, {auth_code}, API.RequestHeaders())
          .then(response => {
            if (response.status == 200) {
              // since we are not getting the whole object from response use the one from the form
              commit("VENDOR_CONNECTION_SUCCESS", response.data);
              resolve();
            } else {
              commit("VENDOR_REQUEST_FAILED", response.data); // TODO - Make all these commit mutations
              reject(response);
            }
          })
          .catch(error => {
            commit("VENDOR_REQUEST_FAILED", error.message); // TODO - Make all these commit mutations
            reject(error.message);
          });
      });
    },

    getStripeCustomer({ rootState }, id) {
      let { stripe_id } = rootState.vendor.vendor
      let api_uri = `${ API.BASE_URL }/vendor/stripe/terminal/customers/${ id }`;

      api_uri = `${ api_uri }?stripe_id=${ stripe_id }`

      return new Promise((resolve, reject) => {
        return axios
          .get(api_uri, API.RequestHeaders())
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if (error.response.status === 400) {
              reject(error.response.data)
            } else {
              reject(error.message);
            }
          });
      });
    },

    addStripeCardHold({ rootState }, payload) {
      let { id, stripe_id } = rootState.vendor.vendor
      let api_uri = `${ API.BASE_URL }/vendor/stripe/charges/create`;

      if (payload.metadata) {
        payload.metadata.vendor_id = id;
      }

      let params = {
        ...payload,
        vendor_id: id,
        stripe_id
      }

      return new Promise((resolve, reject) => {
        return axios
          .post(api_uri, params, API.RequestHeaders())
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if (error.response.status === 400) {
              reject(error.response.data)
            } else {
              reject(error.message);
            }
          });
      });
    },

    getStripeWebHookEndpoints({ commit }) {
      let api_uri = `${ API.BASE_URL }/vendor/stripe/webhook-endpoints`;

      return new Promise((resolve, reject) => {
        return axios
          .get(api_uri, API.RequestHeaders())
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if (error.response.status === 400) {
              reject(error.response.data)
            } else {
              reject(error.message);
            }
          });
      });
    },

    createStripeWebHookEndpoint({ commit }, payload) {
      let api_uri = `${ API.BASE_URL }/vendor/stripe/webhook-endpoints`;

      return new Promise((resolve, reject) => {
        return axios
          .post(api_uri, payload, API.RequestHeaders())
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if (error.response.status === 400) {
              reject(error.response.data)
            } else {
              reject(error.message);
            }
          });
      });
    },

    getChannexStatus ({ commit }) {
      commit('VENDOR_REQUEST_START');

      return axios.get(`${ API.BASE_URL }${ API.CHANNEX_STATUS }`, API.RequestHeaders())
        .then(res => {
          commit('VENDOR_REQUEST_SUCCESS');
          return commit('SET_CHANNEX_STATUS', res.data.status);
        })
        .catch(error => {
          commit('VENDOR_REQUEST_FAILED', error.message);
          commit('SET_CHANNEX_STATUS', false);
        });
    },

    setChannexStatus ({ commit }, payload) {
      commit('SET_CHANNEX_STATUS', payload);
    },

    getChannexRoomTypes ({ commit }) {
      return axios.get(`${ API.BASE_URL }${ API.CHANNEX_ROOM_LIST }`, API.RequestHeaders())
        .then(res => {
          commit('SET_CHANNEX_ROOM_TYPES', res.data);
        })
        .catch(error => {
          commit('SET_CHANNEX_ROOM_TYPES', []);
        });
    },
  },
  mutations: {
    VENDOR_REQUEST_START(state) {
      state.isRequesting = true;
    },
    VENDOR_REQUEST_SUCCESS(state) {
      state.isRequesting = false;
    },
    VENDOR_DATA_SUCCESS(state, vendorData) {
      state.isRequesting = false;
      state.vendor = vendorData;
    },
    VENDOR_CONNECTION_SUCCESS(state, data) {
      state.vendor.stripe_id = data.stripe_user_id;
      state.isRequesting = false;
    },
    VENDOR_LOCATION_SUCCESS(state, data) {
      state.vendor.stripe_location_id = data.stripe_location_id;
    },
    VENDOR_REQUEST_FAILED(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    SET_CHANNEX_STATUS (state, payload) {
      state.channexStatus = payload;
    },
    SET_CHANNEX_ROOM_TYPES (state, payload) {
      state.channexRoomTypes = payload;
    }
  },
  getters: {
    getVendor(state) {
      return state.vendor;
    },
    isRequesting(state) {
      return state.isRequesting;
    },
    isErrored(state) {
      return state.errored;
    },
    getError(state) {
      return state.error;
    },
    channexStatus: (state) => state.channexStatus,
    channexRoomTypes: (state) => state.channexRoomTypes
      .map(r => ({
        id: r.id,
        title: `${ r.title } (occ: ${ r.default_occupancy })`
      }))
  }
};
